import { Components, Theme } from '@mui/material/styles';

export const sidebarTheme: Components<Theme>['MuiDrawer'] = {
  // styleOverrides: {},
  // variants: [],
};
